import React, {Component} from 'react';
import Action from 'components/organisms/player-combination-stacking/actions';
import {connect} from 'react-redux';

class RemoveCombinationItem extends Component {
    onClick(itemId) {
        this.props.dispatch(Action.do('removeItemOfPlayerCombinationStacking', itemId));
    }

    render() {
        const {itemId} = this.props;

        return <span onClick={() => ::this.onClick(itemId)} className="tag-remove"></span>;
    }
}

export default connect(() => ({}))(RemoveCombinationItem);
